module.exports = __webpack_public_path__ + "img/Chae.3b211a9b.png";